export type SpaceType = 'investor' | 'startup' | 'accelerator'

export enum NotificationType {
  NOTIFICATION = 'NOTIFICATION',  
  TASK = 'TASK',
  READONLY = 'READONLY',
}

export enum ReceiverType {
  COMPANY_USER = 'COMPANY_USER',
  COMPANY_EXPERT = 'COMPANY_EXPERT',
  PORTFOLIO_USER = 'PORTFOLIO_USER',
  STAKEHOLDER = 'STAKEHOLDER',
  PORTFOLIO = 'PORTFOLIO'
}

export interface NotificationStatus {
  id: number;
  name: string;
}

export interface NotificationCompany {
  id: number;
  name: string;
  logo?: string;
}

export interface NotificationSender {
  id: number;
  name: string;
  profileImage?: string;
}

export interface NotificationPortfolio {
  id: number;
  name: string;
  logo?: string;
}

export interface NotificationProps {
  unreadCount: number;
  data: Notification[];
  meta: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
  }
}

/** 미읽음 알림 개수 응답 */
export interface UnreadCountResponse {
  taskCount: number;
  notificationCount: number;
  readonlyCount: number;
}


export interface Notification {
  id: string;
  type: NotificationType;
  receiverType: ReceiverType;
  status: NotificationStatus;
  service?: string;
  company: NotificationCompany;
  portfolio?: NotificationPortfolio;
  sender?: NotificationSender;
  url: string | null;
  message: string;
  description?: string;
  createdAt: string;
  isComment: boolean;
}
